import Advantages from '../components/advantages/Advantages';
import Banners from '../components/banner/Banners';
import BlogSlider from '../components/blogSlider/BlogSlider';
import CategoryGrid from '../components/categoryHomePage/CategoryGrid';
import Faq from '../components/faq/Faq';
import ProductSlider from '../components/product/ProductSlider';
import SurveySlider from '../components/surveySlider/SurveySlider';

function HomePage() {
  return (
    <>
      <Banners />
      <Advantages />
      <CategoryGrid />
      <ProductSlider />
      <SurveySlider />
      {/* <BlogSlider /> */}
      <Faq />
    </>
  );
}

export default HomePage;
